import { FC, useEffect, useState } from 'react';

import classes from './styles.module.css';

const Letter:FC<{ letter: string; index: number }> = ({ letter, index }) => {
  const [flip, setFlip] = useState<boolean>(false);

  useEffect(() => {
    const t = setTimeout(() => setFlip(true), 100 * index);
    return () => clearTimeout(t);
  }, [index]);

  return (
    <span className={`
      ${flip ? classes.flip : ''}
      ${!letter.trim() ? classes.space : ''}
    `}>
      {flip ? letter : null}
    </span>
  );
}

const Word:FC<{ word: string }> = ({ word }) => (
  <span>
    {Array.from(word).map((letter, index) => (
      <Letter key={index} letter={letter} index={index} />
    ))}
  </span>
)

export default Word;
